/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "LeChristopher Blackwell | Full-Stack Engineer & AI Specialist",
  description:
    "Full-stack engineer with 8+ years of experience specializing in AI/ML integration, data warehousing, and scalable web applications. IBM Generative AI certified. Passionate about LLMs, prompt engineering, and building intelligent systems.",
  og: {
    title: "LeChristopher Blackwell Portfolio",
    type: "website",
    url: "https://codeblackwell.ai/",
  },
};

//Home Page
const greeting = {
  title: "LeChristopher Blackwell",
  logo_name: "LeChristopherBlackwell",
  nickname: "codeblackwell",
  subTitle:
    "Building the future with AI. Full-stack engineer specializing in LLMs, data pipelines, and scalable web applications. Passionate about prompt engineering, machine learning, and turning complex problems into elegant solutions.",
  resumeLink: "./LeChristopher_Blackwell_Resume.pdf",
  portfolio_repository: "https://github.com/codeblackwell/codeblackwell.github.io",
  githubProfile: "https://github.com/codeblackwell",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/codeblackwell",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/codeblackwell/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/codeblackwell",
    fontAwesomeIcon: "fa-x-twitter",
    backgroundColor: "#000000",
  },
  {
    name: "Gmail",
    link: "mailto:codeblackwell@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
];

const skills = {
  data: [
    {
      title: "AI & Machine Learning",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building and fine-tuning LLMs using LangChain, HuggingFace, and custom PEFT/LoRA techniques",
        "⚡ Developing AI-powered applications with RAG pipelines and prompt engineering",
        "⚡ Creating multi-agent AI systems for automated software development workflows",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#1C3C3C",
          },
        },
        {
          skillName: "HuggingFace",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: {
            color: "#FFD21E",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive web applications using React, Next.js, and TypeScript",
        "⚡ Developing scalable backend services with Python, Node.js, and GraphQL",
        "⚡ Creating robust APIs and data pipelines with PostgreSQL, Snowflake, and Redis",
      ],
      softwareSkills: [
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E10098",
          },
        },
        {
          skillName: "Go",
          fontAwesomeClassname: "simple-icons:go",
          style: {
            color: "#00ADD8",
          },
        },
      ],
    },
    {
      title: "Cloud & Data Infrastructure",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Designing and deploying cloud infrastructure on AWS, Heroku, and Kubernetes",
        "⚡ Building data warehousing solutions with Snowflake, Redshift, and PostgreSQL",
        "⚡ Implementing CI/CD pipelines with GitHub Actions, Jenkins, and Docker",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Snowflake",
          fontAwesomeClassname: "simple-icons:snowflake",
          style: {
            color: "#29B5E8",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "simple-icons:redis",
          style: {
            color: "#DC382D",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#2088FF",
          },
        },
      ],
    },
  ],
};

// Education Page
const educationHeader = {
  title: "Education",
  description:
    "I learn by building. When I encounter a problem, curiosity and conviction drive me to find a better way. That pursuit becomes my classroom. My education comes from implementing research papers, fine-tuning transformer models, and shipping production systems. From PEFT/LoRA optimization techniques discovered through Hugging Face documentation to penetration testing methodologies from security publications, every project in my portfolio represents applied learning. I supplement hands-on development with structured courses from Coursera and IBM, ensuring my skills stay current with industry best practices.",
};

const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackTheBox",
      iconifyClassname: "simple-icons:hackthebox",
      style: {
        color: "#9FEF00",
      },
      profileLink: "https://app.hackthebox.com/",
    },
    {
      siteName: "GitHub",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "#181717",
      },
      profileLink: "https://github.com/codeblackwell",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "IBM / Coursera",
      subtitle: "Generative AI Engineering Specialist Certification",
      logo_path: "ibm_logo.png",
      alt_name: "IBM Certification",
      duration: "January 2025 - March 2025",
      descriptions: [
        "⚡ Completed comprehensive training in Generative AI foundational models for NLP",
        "⚡ Specialized in RAG pipelines, LangChain, and transformer architectures",
        "⚡ Hands-on experience with data preparation and AI architecture design",
      ],
      website_link: "https://www.coursera.org/",
    },
    {
      title: "Hack Reactor",
      subtitle: "Software Engineering Immersive Bootcamp",
      logo_path: null,
      alt_name: "Hack Reactor",
      duration: "January 2016 - April 2016",
      descriptions: [
        "⚡ Intensive full-stack JavaScript development program",
        "⚡ Built multiple production-ready web applications using React and Node.js",
        "⚡ Gained expertise in algorithms, data structures, and software architecture",
      ],
      website_link: "https://www.hackreactor.com/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "IBM Generative AI Engineering",
      subtitle: "- Specialization",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Data Analysis with Python",
      subtitle: "- IBM/Coursera",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Generative AI with RAG & LangChain",
      subtitle: "- IBM/Coursera",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "AI Language Modeling with Transformers",
      subtitle: "- IBM/Coursera",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internships & Volunteerships",
  description:
    "8+ years crafting scalable software across AI/ML, full-stack development, and data engineering. From startup velocity to enterprise scale, I thrive at the intersection of cutting-edge technology and real-world impact.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Fullstack Software Engineer",
          company: "Revic.ai",
          company_url: "https://revic.ai/",
          logo_path: null,
          duration: "August 2025 - September 2025",
          location: "San Francisco, CA",
          descriptionBullets: [
            "Drove rapid feature development in a high-paced AI startup, building scalable web applications and admin interfaces with Python, React, and Docker",
            "Spearheaded development of an Administrator interface, significantly reducing response time for customer customization requests",
            "Engineered robust data models and efficient APIs using PostgreSQL and GraphQL, improving data retrieval speed by 25%",
            "Built Multi-Agentic Architecture systems to optimize sales lead generation and qualification workflows",
            "Integrated AWS S3 for scalable data storage and asset management across the platform",
          ],
          color: "#6366F1",
        },
        {
          title: "Software Engineer",
          company: "AvantLink",
          company_url: "https://www.avantlink.com/",
          logo_path: null,
          duration: "October 2020 - June 2025",
          location: "Park City, UT",
          descriptionBullets: [
            "Drove innovation in an agile SaaS environment over 5 years",
            "Architected real-time analytics dashboards providing management with actionable insights",
            "Built robust automation frameworks integrating AI and React into critical workflows",
            "Pioneered R-based machine learning solutions for data optimization",
            "Developed comprehensive integration test suites for AI services",
            "Streamlined releases via GitHub Actions CI/CD",
            "Initiated development of an advanced LLM application prototype",
          ],
          color: "#10B981",
        },
        {
          title: "QA Engineer",
          company: "AvantLink",
          company_url: "https://www.avantlink.com/",
          logo_path: null,
          duration: "October 2018 - October 2020",
          location: "Park City, UT",
          descriptionBullets: [
            "Transformed QA processes through automation and innovation",
            "Built Python testing frameworks that reduced release cycles by 30%",
            "Executed comprehensive API validation, boosting user satisfaction by 15%",
            "Partnered with Data Warehousing Engineers to improve data accuracy by 25%",
            "Revamped API functionalities with UI/UX teams, elevating engagement metrics",
            "Developed end-to-end automated testing (Python + JavaScript), increasing efficiency by 40%",
            "Mastered Snowflake schemas and data warehousing practices",
          ],
          color: "#10B981",
        },
        {
          title: "Automation Engineer",
          company: "Openside",
          company_url: "https://www.openside.com/",
          logo_path: null,
          duration: "March 2018 - October 2018",
          location: "Provo, UT",
          descriptionBullets: [
            "Engineered automation solutions that transformed business operations",
            "Streamlined workflows by 30% through advanced software integrations",
            "Built custom Airtable & Zapier solutions, cutting repetitive tasks by 40%",
            "Translated complex client requirements into automation strategies (95% satisfaction)",
            "Designed database architectures that improved data retrieval by 50%",
            "Led a development team building user-friendly applications",
          ],
          color: "#F59E0B",
        },
        {
          title: "Frontend Software Engineer",
          company: "Stylisted",
          company_url: "https://www.stylisted.com/",
          logo_path: null,
          duration: "November 2016 - January 2017",
          location: "Chicago, IL",
          descriptionBullets: [
            "Launched innovative features for web and mobile platforms in education sector",
            "Tackled technical debt by optimizing React/Redux architecture for maintainability",
            "Leveraged ImmutableJS for significant performance improvements",
            "Led CRM integration as technical lead with Marketing & Analytics teams",
            "Drove CI/CD pipeline improvements for faster, more reliable deployments",
            "Utilized AWS services to enhance infrastructure reliability and scalability",
          ],
          color: "#EC4899",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Every project here is deployed and live. From autonomous trading systems to AI-powered portfolio reasoning, multi-agent PRD generation to Active Directory attack path visualization — each one solves a real problem with a production stack I built end to end.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Featured Projects",
  description:
    "Live applications spanning AI agents, security tooling, data validation, and infrastructure — all deployed and running.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "academic-ancestry",
      name: "Academic Ancestry",
      createdAt: "2026-10-01T00:00:00Z",
      description:
        "Who taught the people who taught you? Type a researcher and see their advisors and students up and down the line, with examiners, coauthors and colleagues beside them. 2.3 million theses from 220 repositories in 29 countries, joined to Wikidata and OpenAlex, and every edge names its source. Python + Postgres API, React Router front end, and an MCP server so agents can ask the record too. Runs on AWS.",
      url: "https://academicancestry.org",
      image: require("./assets/images/academic_ancestry_screenshot.webp"),
    },
    {
      id: "vizardry",
      name: "Vizardry",
      createdAt: "2026-08-13T00:00:00Z",
      description:
        "A Claude Code plugin for data visualization that holds up. /datastorm profiles any dataset and writes a self contained report of 12 to 20 chart options, each drawn live from the real data with its failure mode stated. 212 React + D3 exemplars, a dialect where React owns rendering and D3 owns math, and verifiers that render every chart in a headless harness before it ships. Open source on GitHub.",
      url: "https://github.com/CodeBlackwell/vizardry",
      image: require("./assets/images/vizardry_screenshot.webp"),
    },
    {
      id: "maisight",
      name: "mAiSight",
      createdAt: "2026-08-16T00:00:00Z",
      description:
        "Bidirectional glossary highlighting for jargon heavy documents. Feed in Markdown, an OpenAPI spec, or an arXiv paper and get a reading page where every defined term lights up in the prose and in a glossary rail that follows your scroll. Ships as a hosted reader, an embed widget for existing docs sites, and a browser extension, with analytics on which terms readers look up most. Python/FastAPI + React/Vite with Claude extraction, deployed on Hetzner.",
      url: "https://maisight.codeblackwell.ai",
      image: require("./assets/images/maisight_screenshot.webp"),
    },
    {
      id: "specter-1",
      name: "SPECTER·1",
      createdAt: "2026-05-15T00:00:00Z",
      description:
        "Byzantine-resilient cooperative SLAM workshop. Interactive in-browser simulator for adversarial multi-agent mapping — replay storms, sybil floods, collusion attacks. TypeScript sim-core runs entirely client-side; React + Vite SPA shipped via GitHub Actions to Hetzner.",
      url: "https://specter.codeblackwell.ai",
      image: require("./assets/images/specter_screenshot.webp"),
    },
    {
      id: "agentopolis",
      name: "Agentopolis",
      createdAt: "2026-06-13T00:00:00Z",
      description:
        "Watch your codebase build itself as a living isometric city. Claude Code agents become citizens, repos become districts — forge a city from any GitHub URL. Published to PyPI (uv tool install agentopolis); FastAPI + canvas, hosted demo deployed on Hetzner.",
      url: "https://agentopolis.codeblackwell.ai",
      image: require("./assets/images/agentopolis_screenshot.webp"),
    },
    {
      id: "spice",
      name: "SPICE (Retired)",
      createdAt: "2026-03-01T00:00:00Z",
      description:
        "Autonomous crypto trading engine. Real-time market analysis, automated strategy execution, and a full trading cockpit — built on FastAPI, React, PostgreSQL/TimescaleDB, and Redis. Decommissioned 2026-08-10.",
      url: "",
      image: require("./assets/images/spice_screenshot.webp"),
    },
    {
      id: "prove",
      name: "PROVE",
      createdAt: "2026-03-20T00:00:00Z",
      description:
        "Your skills, verified by code. Ingests your resume and GitHub repos into a Neo4j knowledge graph, then lets anyone query your abilities with cited evidence, GitHub links, and proficiency scores — powered by Claude and vector search.",
      url: "https://prove.codeblackwell.ai",
      image: require("./assets/images/prove_screenshot.webp"),
    },
    {
      id: "panel",
      name: "PANEL",
      createdAt: "2026-03-22T00:00:00Z",
      description:
        "PRD from Agent Negotiation & Expert Logic. Type an idea, watch 13 AI agents debate architecture, security, and UX, then 3 judges score the result. Downloads a complete PRD package with transcripts and structured exports.",
      url: "https://panel.codeblackwell.ai",
      image: require("./assets/images/panel_screenshot.webp"),
    },
    {
      id: "bloodtrail",
      name: "BloodTrail",
      createdAt: "2026-03-10T00:00:00Z",
      description:
        "BloodHound attack path visualizer. Upload SharpHound data and instantly see Active Directory attack chains ranked by severity — dual graph view, execution playbooks with copy-paste commands, and thermal heatmap modes.",
      url: "https://bloodtrail.codeblackwell.ai",
      image: require("./assets/images/bloodtrail_screenshot.webp"),
    },
    {
      id: "crackpedia",
      name: "Crackpedia",
      createdAt: "2026-02-15T00:00:00Z",
      description:
        "Pentesting command encyclopedia. 54 attack chains, cheatsheets, and writeups with Neo4j-powered graph visualization. Browse by category, search by technique, and walk through step-by-step execution paths.",
      url: "https://crackpedia.codeblackwell.ai",
      image: require("./assets/images/crackpedia_screenshot.webp"),
    },
    {
      id: "veridatum",
      name: "Veridatum",
      createdAt: "2026-02-01T00:00:00Z",
      description:
        "Multi-source data validation. Upload CSVs from Shopify, Stripe, NetSuite — any system — and instantly see every discrepancy. Auto-detects join keys, configurable tolerances, pairwise comparisons with downloadable results.",
      url: "https://veridatum.codeblackwell.ai",
      image: require("./assets/images/veridatum_screenshot.webp"),
    },
    {
      id: "methodproof",
      name: "MethodProof",
      createdAt: "2026-05-01T00:00:00Z",
      description:
        "Engineering process intelligence. Captures how you actually think, debug, and build — then turns it into a Neo4j-backed graph that resumes and interviews can't show. Python/FastAPI + React + Chrome extension + mobile, deployed on AWS ECS with RDS, Redis, and CloudFront. Three provisional patents filed.",
      url: "https://methodproof.com",
      image: require("./assets/images/methodproof_screenshot.webp"),
    },
  ],
};

// Consulting Page
const consultingHeader = {
  title: "Consulting",
  description:
    "Client work I built end to end, running in production behind access control. The systems below are live, but the data and the decisions inside them belong to the people who commissioned them. What you can read here is the shape of the problem and the stack that solved it. Credentials on request.",
  avatar_image_path: "projects_image.svg",
};

const consulting = {
  data: [
    {
      id: "fourth-axis",
      name: "Fourth Axis",
      client: "Defense acquisition consultancy",
      period: "2026",
      description:
        "An acquisition strategy workbench for a firm advising on federal defense programs. It takes program documents and market context and produces structured acquisition pathways: the comparisons, tradeoffs, and framing a principal walks into a client engagement holding. Built as a single tenant internal tool by design, not a SaaS product.",
      stack: ["Express", "React", "Vite", "Claude API", "SQLite", "Docker"],
      url: "https://generic.codeblackwell.ai",
      access: "Basic auth",
    },
    {
      id: "cadre",
      name: "CADRE",
      client: "Federal research sponsor",
      period: "2026",
      description:
        "Maps national defense priority mission domains onto US research institutions and ranks the matches with cited, auditable evidence. Every claim traces back to a federal award record, a publication, or an enrollment filing. No unsourced assertions. The hard part was never the graph; it was making the evidence hold up to scrutiny.",
      stack: ["Python", "FastAPI", "Neo4j", "SQLite", "D3.js", "Claude API"],
      url: "https://cadre.codeblackwell.ai",
      access: "Named accounts",
    },
  ],
};

// Workshop Page
const workshopData = {
  title: "The Workshop",
  hint: "Hover a ring to inspect, click to explore.",
  apiUrl: "https://prove.codeblackwell.ai/api/repositories",
  palette: [
    "#5a8a6a",
    "#4a7ab5",
    "#b8864e",
    "#7a5195",
    "#c0392b",
    "#2c8c99",
    "#8b6d3f",
    "#6a5acd",
    "#d4726a",
    "#3a7d5e",
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "LeAvatar.png",
    description:
      "I'm always open to discussing new projects, AI/ML opportunities, or interesting technical challenges. Feel free to reach out via email or connect on social media.",
  },
  blogSection: {
    title: "Blog",
    subtitle:
      "I write about AI, software engineering, and lessons learned building scalable systems.",
    link: "https://medium.com/@CodeBlackwell",
    avatar_image_path: "blogs_image.svg",
    posts: [
      {
        title: "MonitorsFour: From Zero to Docker Desktop Escape",
        url:
          "https://medium.com/@CodeBlackwell/monitorsfour-from-zero-to-docker-desktop-escape-af1b2522de35",
        image:
          "https://miro.medium.com/v2/resize:fit:720/format:webp/1*dCqnOHkLeJ4d7C1gt1NQQw.jpeg",
      },
    ],
  },
  addressSection: {
    title: "Location",
    subtitle: "San Francisco, CA, USA",
    locality: "San Francisco",
    country: "USA",
    region: "California",
    postalCode: "94102",
    streetAddress: "San Francisco",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/San-Francisco",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

// Beyond The Keys Page - Personal Passions
const beyondPageData = {
  title: "Beyond The Keys",
  subtitle: "What Fuels My Fire Outside of Code",
  description:
    "Life is more than lines of code. These passions keep me balanced, creative, and constantly growing.",
  passions: [
    {
      id: "flow-arts",
      name: "Flow Arts",
      description:
        "There's magic in creating so much from so little. A staff is just a stick. A slackline is 3 inches of elastic between trees. Poi? Balls on string. Yet within these simple tools lives infinite expression.",
      image_path: "passions/flow-arts.jpg",
      video_path: "passions/flow-arts.mp4",
      instagram_url: "",
      tiktok_url: "",
      color_code: "#9b5de5",
    },
    {
      id: "martial-arts",
      name: "Martial Arts",
      description:
        "Kung Fu: adroitness acquired over time with great effort. Not a fighting style, but a philosophy. The discipline to show up, the humility to learn, and the patience to trust the process.",
      image_path: "passions/martial-arts.jpg",
      video_path: "passions/martial-arts.mp4",
      instagram_url: "",
      tiktok_url: "",
      color_code: "#dc2f02",
    },
    {
      id: "fire-dancing",
      name: "Fire Dancing",
      description:
        "Inspire and be inspired. Feel joy and spread joy. I've always been a dancer. I've always been fascinated with fire. Combining the two just seemed like a natural progression.",
      image_path: "passions/fire-dancing.jpg",
      video_path: "passions/fire-dancing.mp4",
      instagram_url: "",
      tiktok_url: "",
      color_code: "#ff6b35",
    },
    {
      id: "outdoors",
      name: "Outdoors",
      description:
        "The place I love most? Anywhere. Everywhere. Mountains, forests, deserts, coastlines - each landscape offers its own lessons. Nature has a way of putting everything into perspective.",
      image_path: "passions/outdoors.jpg",
      video_path: "passions/outdoors.mp4",
      instagram_url: "",
      tiktok_url: "",
      color_code: "#55a630",
    },
    {
      id: "travel",
      name: "Travel",
      description:
        "The best part about travel is the people. Every place has its own culture, activities, cuisines, and norms. There are so many ways to be a beautiful person and build beautiful community. I treasure opportunities to truly learn how others do things.",
      image_path: "passions/travel.jpg",
      video_path: "passions/travel.mp4",
      instagram_url: "",
      tiktok_url: "",
      color_code: "#0e6ba8",
    },
  ],
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  educationHeader,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  consultingHeader,
  consulting,
  contactPageData,
  beyondPageData,
  workshopData,
};
